/**
 * Why the save of a review in quantities cannot go out yet, first reason first. Deleted rows count for
 * nothing but the cash they free.
 */
import { hasNegativeCash } from "$root/functional-areas/instruments-editor/quantity/derive";
import { isUnpriced } from "$root/functional-areas/instruments-editor/quantity/market-date/pricing";
import { isSizing, isSizingFailed } from "$root/functional-areas/instruments-editor/quantity/position-sizing/sizing";
import { needsReview } from "../reviewRows";
import type { QuantityReviewRow } from "./rows";
import { isUnvaluedSynthetic } from "./synthetic";

export type ReviewSaveCheck =
	| { kind: "ok" }
	| { kind: "needsReview" }
	| { kind: "sizingPending" }
	| { kind: "sizingFailed" }
	| { kind: "unsized" }
	| { kind: "unvaluedSynthetic" }
	| { kind: "unpriced" }
	| { kind: "negativeCash" };

export function reviewSaveCheck(rows: QuantityReviewRow[], aum: number): ReviewSaveCheck {
	if (rows.some(needsReview)) {
		return { kind: "needsReview" };
	}
	const kept = rows.filter((row) => !row.deleted);
	if (kept.some(isSizing)) {
		return { kind: "sizingPending" };
	}
	if (kept.some(isSizingFailed)) {
		return { kind: "sizingFailed" };
	}
	if (kept.some((row) => row.aliasUnsized)) {
		return { kind: "unsized" };
	}
	if (kept.some(isUnvaluedSynthetic)) {
		return { kind: "unvaluedSynthetic" };
	}
	if (kept.some(isUnpriced)) {
		return { kind: "unpriced" };
	}
	if (hasNegativeCash(rows, aum)) {
		return { kind: "negativeCash" };
	}
	return { kind: "ok" };
}
